import {
  asUrl,
  getDatetime,
  getStringNoLocale,
  getUrl,
  ThingLocal,
  ThingPersisted,
} from '@inrupt/solid-client'
import { DateTime } from 'luxon'
import { URI } from '../utils/ontology'
import { ThingFactory } from '../utils/ThingFactory'
import { checkType } from './utils'

/**
 * CompletedQuestions
 *
 * representing the answers given by a specific user in a specific survey completion
 * Each CompletedQuestion is characterized by the timestamp in which the answer has been collected,
 * is linked to the the Question that has been answered and specifies the answer(s) given by the user
 */
export class CompletedQuestion {
  protected readonly _thing: ThingPersisted

  constructor(thing: ThingPersisted) {
    checkType(thing, URI.SURVEY_COMPLETED_QUESTION_CLASS)
    this._thing = thing
  }

  get url(): string {
    return asUrl(this._thing)
  }

  get thing(): ThingPersisted {
    return this._thing
  }

  get completesQuestion(): string | undefined {
    return (
      getUrl(this.thing, URI.SURVEY_COMPLETES_QUESTION_PREDICATE) || undefined
    )
  }

  get completionTimestamp(): Date | undefined {
    return (
      getDatetime(this.thing, URI.SURVEY_HAS_COMPLETION_TIMESTAMP_PREDICATE) ||
      undefined
    )
  }

  get hasAnswer(): string | undefined {
    return getUrl(this.thing, URI.SURVEY_HAS_ANSWER_PREDICATE) || undefined
  }

  get hasAnswerText(): string | undefined {
    return (
      getStringNoLocale(this.thing, URI.SURVEY_HAS_ANSWER_TEXT_PREDICATE) ||
      undefined
    )
  }

  // setCompletesQuestion(question: Question): Thing {
  //   return setUrl(
  //     this.thing,
  //     URI.SURVEY_COMPLETES_QUESTION_PREDICATE,
  //     question.thing
  //   )
  // }
  //
  // setCompletionTimeStamp(date: Date): Thing {
  //   return setDatetime(
  //     this.thing,
  //     URI.SURVEY_HAS_COMPLETION_TIMESTAMP_PREDICATE,
  //     date
  //   )
  // }
  //
  // setHasAnswer(answer: Answer): Thing {
  //   return setUrl(this.thing, URI.SURVEY_HAS_ANSWER_PREDICATE, answer.thing)
  // }
}

export const createCompletedQuestion = (
  answeredText: string,
  completionTimeStamp: DateTime,
  questionUrl: string,
  answerThing: ThingLocal
): ThingLocal =>
  new ThingFactory()
    .addUrl(URI.TYPE_PREDICATE, URI.SURVEY_COMPLETED_QUESTION_CLASS)
    .addUrl(URI.SURVEY_COMPLETES_QUESTION_PREDICATE, questionUrl)
    .addUrl(URI.SURVEY_HAS_ANSWER_PREDICATE, answerThing)
    .addStringNoLocale(URI.SURVEY_HAS_ANSWER_TEXT_PREDICATE, answeredText)
    .addDatetime(
      URI.SURVEY_HAS_COMPLETION_TIMESTAMP_PREDICATE,
      completionTimeStamp.toJSDate()
    )
    .build()
